<template>
  <div class="report-service-qualityreport">
    <div class="module-item-style report-filter-container">
      <el-date-picker
              v-model="selectTime"
              type="daterange"
              @change="timeSelect"
              :picker-options="pickerOptions"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="timestamp"
      >
      </el-date-picker>
      <div class="date-detail-filter">
        <div class="date-item" :class="chooseDate == index ? 'date-actived' : ''" v-for="(item, index) in dateOptions"
             :key="index" @click="chooseTime(index,item.value)">{{item
          .name}}</div>
      </div>
      <div class="report-filter-top-button">
        <div class="wl-btn" @click="exportData">导出当前数据</div>
      </div>
    </div>


    <div class="module-item-style">
      <tableBox
              :tableData="tableData"
              :tableHead="tableHead"
              :isLoading="loadingData"
              :total="total"
              :size="pageSize"
              @pageHandler="pageOperate"></tableBox>
    </div>
  </div>
</template>

<script>
  import tableBox from '@/components/table/table'
  export default {
    name: 'report-service-qualityreport',
    components:{
      tableBox
    },
    data() {
      return {
        selectTime:'',
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now() - 8.64e6;//如果没有后面的-8.64e6就是不可以选择今天的
          }
        },
        chooseDate:'0',
        setDate: 'lastday',
        dateOptions:[
          {name:'昨天',value:'lastday'},
          {name:'上周',value:'lastweek'},
          {name:'上月',value:'lastmonth'},
        ],
        startTime: '',
        endTime: '',
        tableData: [],
        tableHead: [
          {
            label: '姓名',
            value: 'cs_name',
            operate: false
          }, {
            label: '平均首次响应时间',
            value: 'avg_first_respond',
            operate: false,
          }, {
            label: '30秒应答率',
            value: 'thirty_respond',
            operate: false
          },{
            label: '平均会话时长',
            value: 'avg_call_time',
            operate: false,
          }, {
            label: '参评率',
            value: 'evaluate_percent',
            operate: false,
          },{
            label: '相对满意度',
            value: 'good_evaluate',
            operate: false,
          }
        ],
        total: 0,
        currentPage: 1,
        loadingData: false,
        pageSize: 10
      }
    },
    created(){
      this.getQualityData()
    },
    mounted() {

    },
    methods: {
      exportData(){
        let exportParams = {}
        if(this.setDate == ''){
          exportParams = {
            startTime:this.startTime,
            endTime:this.endTime,
          }
        }else {
          exportParams = {
            date:this.setDate
          }
        }
        var params = Object.keys(exportParams).map(function (key) {
          // body...
          return encodeURIComponent(key) + "=" + encodeURIComponent(exportParams[key]);
        }).join("&");
        let exportUrl = process.env.VUE_APP_API_URL + '/wlapi/index/outJobQualityExcel?'+params
        window.open(exportUrl)
      },
      /**
       *  分页操作
       * @param val
       */
      pageOperate(val) {
        if (val.type == 'currentChange') {
          this.currentPage = val.val
        } else if (val.type == "sizeChange") {
          this.pageSize = val.val
        }
        this.getQualityData()
      },
      chooseTime(index,val){
        if(this.chooseDate != index){
          this.chooseDate = index
          this.setDate = val
          this.selectTime = ''
          this.startTime = ''
          this.endTime = ''
          this.$nextTick(() => {
            this.getQualityData()
          })
        }

      },
      /**
       * 时间选择
       */
      timeSelect() {
        if(this.selectTime){
          this.startTime = this.selectTime[0] / 1000
          let endTime = this.selectTime[1] / 1000
          this.endTime = endTime + 24 * 60 * 60 - 1
          this.chooseDate = '-1'
          this.setDate = ''
        }else {
          this.startTime = ''
          this.endTime = ''
          this.chooseDate = '0'
          this.setDate = 'lastday'
        }
        this.$nextTick(() => {
          this.getQualityData()
        })
      },
      getQualityData(){
        this.loadingData = true
        this.$http.serviceQualityReportDataAPI({
          pageSize:this.pageSize,
          pageNum:this.currentPage,
          startTime:this.startTime,
          endTime:this.endTime,
          date:this.setDate,
        }).then( res => {
          if(res.status == 1){
            let data = res.data
            this.total = data.count
            this.tableData = data.data
          }
          this.loadingData = false


        }).catch( err => {
          this.loadingData = false
        })
      },
    }
  }
</script>

<style lang="scss">

</style>
